export const PMS_DIST_LOGIN = 'PMS_DIST_LOGIN'
export const PMS_DIST_LOGIN_RESPONSE = 'PMS_DIST_LOGIN_RESPONSE'
export const PMS_DIST_LOGIN_FAIL = 'PMS_DIST_LOGIN_FAIL'


export const PMS_GENERATE_OTP = 'PMS_GENERATE_OTP'
export const PMS_GENERATE_OTP_RESPONSE = 'PMS_GENERATE_OTP_RESPONSE'
export const PMS_GENERATE_OTP_FAIL = 'PMS_GENERATE_OTP_FAIL'

export const RESET_FORGOT_PASSWORD = 'RESET_FORGOT_PASSWORD'
export const RESET_FORGOT_PASSWORD_RESPONSE = 'RESET_FORGOT_PASSWORD_RESPONSE'
export const RESET_FORGOT_PASSWORD_FAIL = 'RESET_FORGOT_PASSWORD_FAIL'
